import { TransactionAllocationTypes, QuoteAllocationTypes } from 'utils/types';

const ROUTES = {
    Login: '/login/:brand',
    Dashboard: '/',
    Underwriting: {
        Home: '/underwriting',
        Renewals: '/underwriting/renewals',
        Assigned: '/underwriting/assigned',
        Actioned: '/underwriting/actioned',
        ClaimsHistory: '/underwriting/claims-history',
    },
    Quote: {
        Home: '/quote/:transactionId',
        Compare: '/quote/:transactionId/compare/:compareId',
        CompareRisk: '/quote/:transactionId/compare/:compareId/risk/:risk',
        CompareDetail: '/quote/:transactionId/compare/:compareId/:detail',
        Risk: '/quote/:transactionId/risk/:risk/:uid?/:subUid?',
        Detail: '/quote/:transactionId/:detail/:uid?',
    },
    Search: '/search',
    Finance: {
        Home: '/finance',
        Statements: '/finance/statements',
        Remittances: '/finance/remittances',
        Remittance: '/finance/:remittanceId/remittance/:remittanceLineId?',
        EmailActivity: '/finance/email-activity',
        Create: '/finance/create',
    },
    Admin: {
        Users: '/admin/users',
        BulkPolicyTransfer: '/admin/bulk-policy-transfer',
        BLUsers: '/admin/bl-users',
        WelcomeEmail: '/admin/welcome-email',
    },
};

const getRouteAttribution = (route, defaultAllocation) => {
    let allocation = null;

    switch (route) {
        case ROUTES.Finance.Home:
            allocation = TransactionAllocationTypes.UNRECONCILED;
            break;

        case ROUTES.Underwriting.Renewals:
            allocation = QuoteAllocationTypes.RENEWAL;
            break;

        case ROUTES.Underwriting.Assigned:
            allocation = QuoteAllocationTypes.ASSIGNED;
            break;

        case ROUTES.Underwriting.Actioned:
            allocation = QuoteAllocationTypes.ACTIONED;
            break;

        case ROUTES.Dashboard:
            allocation = QuoteAllocationTypes.CURRENT;
            break;

        default:
            allocation = defaultAllocation;
            break;
    }

    return allocation;
};

export { ROUTES, getRouteAttribution };
